<template>
    <article class="i-investor-calendar">
        <h2
            class="i-investor-calendar__header"
            :title="'Календарь инвестора'"
            v-html="'Календарь инвестора'"></h2>
        <div class="i-investor-calendar__wrap">
            <h3
                class="i-investor-calendar__title"
                :title="investorCalendarData.name"
                v-html="investorCalendarData.name"></h3>
        </div>
        <div class="i-investor-calendar__footer">
            <span
                class="i-investor-calendar__date"
                v-html="investorCalendarData.date"></span>
            <a
                class="i-investor-calendar__link arrow-btn"
                :href="'/investors/calendar/?emitent=' + emitentId"></a>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'InvestorCalendar',
        props: {
            investorCalendarData: {
                type: Object,
                default: () => {}
            },
            emitentId: {
                type: String,
                default: ''
            }
        }
    }
</script>